import DayjsUtils from '@date-io/dayjs';
import {
	Divider, makeStyles, Table, TableBody, TableCell,
	TableHead, Box, Container, TablePagination, TableRow,
	Radio, Button, Dialog, DialogTitle, DialogActions, DialogContent,
	TableContainer, Tooltip, IconButton, TextField, InputAdornment, SvgIcon
} from '@material-ui/core';
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import * as dayjs from 'dayjs'
import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useActions, useValues } from 'kea';
import AddIcon from '@material-ui/icons/Add';
import { Search as SearchIcon } from "react-feather";
import Fuse from 'fuse.js';

import alertlogic from 'src/store/alert';
import { ralertlogic } from 'src/store/report';
import { minHistoryDate } from 'src/utils/constants';

const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	}
});

const columns = [
	{
		field: 'name',
		headerName: 'Alert Name',
		align: 'left',
		width: 100,
	},
	{
		field: 'actions',
		headerName: 'Actions',
		align: 'right',
		width: 100,
	}
];

const initialAlertDataParam = {
	alert: '',
	start: dayjs().startOf('day'),
	stop: dayjs().endOf('day')
}

const AlertDataDialog = () => {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();
	const { alerts } = useValues(alertlogic);
	const { fetchAll: fetchAllAlert } = useActions(alertlogic);
	const [alertDataParam, setAlertDataParam] = useState(initialAlertDataParam);
	const [open, setOpen] = useState(false);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const { fetch } = useActions(ralertlogic);
	const [filtered, setFiltered] = useState([]);
	const [search, setSearch] = useState('');


	useEffect(() => {
		alerts ?? fetchAllAlert();
	}, []) // eslint-disable-line

	useEffect(() => {
		if (search === '') {
			setFiltered(alerts || []);
		} else {
			const fuse = new Fuse(alerts, {
				keys: ['name']
			});
			let found = fuse.search(search);
			found = found.map(item => {
				item.item.refIndex = item.refIndex;
				return item.item;
			});
			setFiltered(found);
		}
	}, [alerts, search])// eslint-disable-line

	const handleChangePage = (even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	const handleSearch = (e) => setSearch(e.target.value);

	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
	}

	const handleAdd = () => {
		if (!alertDataParam.alert) {
			enqueueSnackbar('Please Select an Alert', { variant: 'error' });
			return
		}
		if (dayjs(alertDataParam.start).isAfter(alertDataParam.stop)) {
			enqueueSnackbar('Please enter correct dates', { variant: 'error' });
			return
		}
		addDataHandler(alertDataParam);
		setAlertDataParam(initialAlertDataParam);
		handleClose();
	}

	const handleChange = (key, value) => {
		let updatedParams = { ...alertDataParam };
		updatedParams[key] = value;
		setAlertDataParam(updatedParams);
	}

	const handleHotKey = (period, value, lastdays = true) => {
		let updatedParams = { ...alertDataParam };
		if (period === 'month') {
			updatedParams.start = dayjs().subtract(value, 'month').startOf('month');
			updatedParams.stop = dayjs().subtract(value, 'month').endOf('month');
		} else if (period === 'week') {
			updatedParams.start = dayjs().subtract(value, 'week').startOf('week');
			updatedParams.stop = dayjs().subtract(value, 'week').endOf('week');
		} else if (period === 'day') {
			updatedParams.start = dayjs().subtract(value, 'day').startOf('day');
			updatedParams.stop = lastdays ? dayjs().subtract(value, 'day').endOf('day') : dayjs().endOf('day');
		}
		setAlertDataParam(updatedParams);
	}

	const addDataHandler = (new_data) => {
		fetch(new_data);
	}

	if (alerts === null) {
		return (
			<></>
		)
	}
	const emptyRows = rowsPerPage - filtered.length % rowsPerPage
	return (
		<>
			<Tooltip title="Generate Report">
				<IconButton aria-label="add" onClick={handleClickOpen}>
					<AddIcon />
				</IconButton>
				{/* <Button
					color="primary"
					variant="contained"
					aria-label="add"
					onClick={handleClickOpen}
				>
					Generate Report
				</Button> */}
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				maxWidth='xl'
			>
				<DialogTitle id="form-dialog-title">Generate Report</DialogTitle>
				<DialogContent>
					<TextField
						fullWidth
						style={{
							paddingBottom: '20px'
						}}
						className={classes.SearchWithToggle}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SvgIcon fontSize="small" color="action">
										<SearchIcon />
									</SvgIcon>
								</InputAdornment>
							),
						}}
						onChange={handleSearch}
						placeholder="Search Alerts"
						variant="outlined"
					/>
					<div style={{ height: '100%', width: '100%', background: 'white' }}>
						<TableContainer className={classes.container}>
							<Table stickyHeader aria-label="sticky table" size={'small'}>
								<TableHead>
									<TableRow>
										{columns.map((column) => (
											<TableCell
												key={column.field}
												align={column.align}
												style={{ minWidth: column.width }}
											>
												{column.headerName}
											</TableCell>
										))}
									</TableRow>
								</TableHead>
								<TableBody>
									{
										filtered && filtered.length > 0 ?
											filtered
												.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
												.map((row) => {
													if (row.condition.monitor === 'offline') {
														return null
													}
													return (
														<TableRow style={{ height: 56 }} hover role="checkbox" tabIndex={-1} key={row._id}>
															{columns.map((column) => {
																if (column.field === 'enabled') {
																	return (
																		<TableCell key={column.field} align={column.align}>
																			{
																				row[column.field] ?
																					'Enabled'
																					:
																					'Disabled'
																			}
																		</TableCell>
																	)
																}
																if (column.field === 'actions') {
																	return (
																		<>
																			<TableCell key={column.field} align={column.align}>
																				<Radio
																					checked={alertDataParam.alert === row._id}
																					onChange={() => handleChange('alert', row._id)}
																					color="primary"
																					inputProps={{ 'aria-label': 'secondary checkbox' }}
																				/>
																			</TableCell>
																		</>
																	)
																}
																if (column.field === 'info') {
																	return (
																		<>
																			<TableCell key={column.field} align={column.align}>
																				{`${row.year} ${row.company} ${row.model} ${row.color}`}
																			</TableCell>
																		</>
																	)
																}
																const value = row[column.field];
																return (
																	<TableCell key={column.field} align={column.align}>
																		{column.format && typeof value === "number"
																			? column.format(value)
																			: value}
																	</TableCell>
																);
															})}
														</TableRow>
													);
												})
											: <TableRow>
												<TableCell style={{ height: 56 * rowsPerPage }} colSpan={5} align={'center'}>
													No Alerts found.
												</TableCell>
											</TableRow>
									}
									{
										filtered.length > 0 && emptyRows > 0 && (
											<TableRow style={{ height: 56 * emptyRows }}>
												<TableCell colSpan={6} />
											</TableRow>
										)
									}
								</TableBody>
							</Table>
						</TableContainer>
						{/* </Paper> */}
					</div>
				</DialogContent>
				<DialogActions>
					<Container maxWidth={false}>
						<Box>
							<TablePagination
								rowsPerPageOptions={[10, 15, 20]}
								component="div"
								count={filtered ? filtered.length : 0}
								rowsPerPage={rowsPerPage}
								page={page}
								onChangePage={handleChangePage}
								onChangeRowsPerPage={handleChangeRowsPerPage}
							/>
							<Divider />
						</Box>
						<Box>
							<div style={{ paddingTop: '15px', paddingBottom: '15px', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
								<div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
									<Button onClick={() => handleHotKey('day', 30, false)} color="primary">
										Last 30 Days
									</Button>
									<Button onClick={() => handleHotKey('month', 1)} color="primary">
										Last Month
									</Button>
									<Button onClick={() => handleHotKey('week', 1)} color="primary">
										Last Week
									</Button>
									<Button onClick={() => handleHotKey('day', 1)} color="primary">
										Last Day
									</Button>
								</div>
								<div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
									<div style={{ minWidth: '50px' }} >
										<MuiPickersUtilsProvider utils={DayjsUtils}>
											<DateTimePicker
												autoOk
												ampm={false}
												variant="inline"
												label="Start"
												minDate={minHistoryDate}
												value={alertDataParam.start}
												onChange={(value) => handleChange('start', value)}
												disableFuture
											/>
										</MuiPickersUtilsProvider>
									</div>
									<div style={{ minWidth: '50px' }} />
									<MuiPickersUtilsProvider utils={DayjsUtils}>
										<DateTimePicker
											autoOk
											ampm={false}
											variant="inline"
											label="Stop"
											value={alertDataParam.stop}
											onChange={(value) => handleChange('stop', value)}
											disableFuture
											minDate={alertDataParam.start}
											minDateMessage={'Date should not be before \'Start date\''}
										/>
									</MuiPickersUtilsProvider>
								</div>
							</div>
							<Divider />
						</Box>
						<Box>
							<div style={{ paddingTop: '15px', paddingBottom: '15px', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>

								<Button onClick={handleClose} color="primary">
									Cancel
								</Button>
								<Button onClick={handleAdd} color="primary">
									Generate
								</Button>
							</div>
						</Box>
					</Container>
				</DialogActions>
			</Dialog >
		</ >
	)
}

AlertDataDialog.propTypes = {
}

export default AlertDataDialog
